import { useTranslation } from 'react-i18next';

export const CardStatusSelectFilters = (t: any) => {
  return [
    { label: 'World Card', value: 'WORLD' },
    { label: 'World Elite Card', value: 'WORLD ELITE' },
    { label: 'Platinum Card', value: 'PLATINUM' }
  ];
};

export const CardIdentityTypeSelectFilters = (t: any) => {
  return [
    { label: t('card-account::credit-card-new-account.glossary.individual'), value: 'individual' },
    { label: t('card-account::credit-card-new-account.glossary.corporate'), value: 'corporate' }
  ];
};

export const CardAccountTypeSelectFilters = (t: any) => {
  return [
    { label: t('card-account::credit-card-new-account.glossary.asset-link'), value: 'asset-link' },
    { label: t('card-account::credit-card-new-account.glossary.prepaid'), value: 'prepaid' },
    { label: t('card-account::credit-card-new-account.glossary.fixed-limit'), value: 'fixed-limit' }
  ];
};

export const CardCurrencySelectFilters = (t: any) => {
  return [
    { label: 'HKD', value: 'HKD' },
    { label: 'USD', value: 'USD' }
  ];
};

export const CardIndividualDocumentTypeSelectFilters = (t: any) => {
  return [
    { label: t('card-account::credit-card-new-account.glossary.passport'), value: 'passport' },
    { label: t('card-account::credit-card-new-account.glossary.driving-license'), value: 'drivers-license' },
    { label: t('card-account::credit-card-new-account.glossary.id'), value: 'national-id' }
  ];
};

export const CardAccountTypeFilters = (t: any) => {
  return [
    { label: t('card-account::credit-card-new-account.glossary.asset-link'), value: 'asset-link' },
    { label: t('card-account::credit-card-new-account.glossary.prepaid'), value: 'prepaid' },
    { label: t('card-account::credit-card-new-account.glossary.fixed-limit'), value: 'fixed-limit' }
  ];
};

export const CardKycStatusFilters = (t: any) => {
  return [
    { label: t('card-account::credit-card-new-account.glossary.pending'), value: 'PENDING_APPROVAL' },
    { label: t('card-account::credit-card-new-account.glossary.approved'), value: 'APPROVED' },
    { label: t('card-account::credit-card-new-account.glossary.rejected'), value: 'REJECTED' }
  ];
};
